import React from "react";
import "./Footer.css";
import logo from "../../../images/logo.png";
import { Link } from "react-router-dom";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaChevronRight,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container">
          <div className="row g-4">
            <div className="col-12 col-sm-6 col-lg-3">
              <div className="footer-widget footer-about">
                <div className="footer-logo">
                  <Link to="/">
                    <img
                      src={logo}
                      alt="Rodgers Angala Logo"
                      className="footer-logo__img"
                    />
                  </Link>
                </div>
                <p className="footer-about__text">
                  Full-Stack Developer, Technical Lead, and IT Manager focused
                  on building secure web and mobile applications, AI-powered
                  systems, scalable APIs, and high-performance digital
                  solutions.
                </p>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="footer-widget footer-menu">
                <h3 className="footer-title">Quick links</h3>
                <ul className="footer-list">
                  <li>
                    <Link to="/about">
                      <FaChevronRight className="footer-list__icon" /> About me
                    </Link>
                  </li>
                  <li>
                    <Link to="/projects">
                      <FaChevronRight className="footer-list__icon" /> Projects
                    </Link>
                  </li>
                  <li>
                    <Link to="/resume">
                      <FaChevronRight className="footer-list__icon" /> Resume
                    </Link>
                  </li>
                  <li>
                    <Link to="/contact">
                      <FaChevronRight className="footer-list__icon" /> Contact
                    </Link>
                  </li>
                  <li>
                    <Link to="/blog">
                      <FaChevronRight className="footer-list__icon" /> Blog
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="footer-widget footer-menu">
                <h3 className="footer-title">Services</h3>
                <ul className="footer-list">
                  <li>
                    <Link to="/services">
                      <FaChevronRight className="footer-list__icon" /> Web
                      Development
                    </Link>
                  </li>
                  <li>
                    <Link to="/services">
                      <FaChevronRight className="footer-list__icon" /> Mobile
                      App Solutions
                    </Link>
                  </li>
                  <li>
                    <Link to="/services">
                      <FaChevronRight className="footer-list__icon" /> API
                      Integration
                    </Link>
                  </li>
                  <li>
                    <Link to="/services">
                      <FaChevronRight className="footer-list__icon" /> AI
                      Integration
                    </Link>
                  </li>
                  <li>
                    <Link to="/services">
                      <FaChevronRight className="footer-list__icon" /> IT
                      Support & Strategy
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col-12 col-sm-6 col-lg-3">
              <div className="footer-widget footer-contact">
                <h3 className="footer-title">Contact me</h3>

                <div className="footer-contact__item">
                  <FaMapMarkerAlt className="footer-contact__icon" />
                  <p>
                    Miracle Plaza, Makadara Road,
                    <br />
                    Mavoko Town, Machakos County, Kenya
                  </p>
                </div>

                <div className="footer-contact__item">
                  <FaPhoneAlt className="footer-contact__icon" />
                  <p>
                    <a href="tel:+254700000000">+254 759 657 192</a> <br />
                    <a href="tel:+254700000000">+254 719 458 048</a>
                  </p>
                </div>

                <div className="footer-contact__item">
                  <FaEnvelope className="footer-contact__icon" />
                  <p>
                    <a href="mailto:your@email.com">angalarodgers@email.com</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-12 col-md-6 text-center text-md-start">
              <p className="footer-copyright">
                &copy; {new Date().getFullYear()} Rodgers Angala. All rights
                reserved.
              </p>
            </div>
            <div className="col-12 col-md-6">
              <ul className="footer-policy">
                <li>
                  <Link to="/terms">Terms & conditions</Link>
                </li>
                <li>
                  <Link to="/policy">Privacy policy</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
